import JSEncrypt from "jsencrypt";
const RSAkey = process.env.REACT_APP_RSA_PUBLIC_KEY?.replace(/\\n/g, "\n");

export const encryption = async (data) => {
  try {
  

    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(RSAkey);
    const encStr = encrypt.encrypt(data);
    return encStr;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
